export const keysFromCapitalToCamelCase = (obj: Object) => {
  return Object.entries(obj)
    .reduce((result, [key, value]) => {
      const newKey = key.charAt(0).toLowerCase() + key.slice(1)

      return {
        ...result,
        [newKey]: value
      }
    }, {})
}